module.exports = __webpack_public_path__ + "media/images/CLR_for_Students_logo-df4bc60bd612178f4ad78689387d067e.png";